import { shortCode } from "../../constants/config";

export const isActionAllowed = (short_code = '') => short_code != shortCode
